<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="contrast w1200">
			<div class="flex famous_position">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/career" class="cl_gray">生涯规划</router-link>
					  >  <router-link to="/choice" class="cl_gray">3+2+1选科</router-link>  >  选科查询系统</p>
				</div>
			</div>
			<div class="choice">
				<div class="choice_nav">
					<router-link to="/choice_subject" class="choice_nav_list f18px cl_dark">按科目组合查专业</router-link>
					<router-link to="/choice_intention" class="choice_nav_list f18px cl_dark on">按意向志愿选科目</router-link>
					<router-link to="/choice_major" class="choice_nav_list f18px cl_dark">按专业名称查科目</router-link>
					<router-link to="/choice_collect" class="choice_nav_collect f18px cl_violet">我的收藏</router-link>
				</div>
				<div class="intent_nav f16px cl_gray tc">
					<span class="intent_nav_list" @click="intentNav(1)" :class="{'on': status==1}">条件筛选</span>
					<span class="intent_nav_list" @click="intentNav(2)" :class="{'on': status==2}">精确筛选</span>
				</div>
				<div class="choice_select intent_select" v-if="status == 1">
					<div class="famous_screen_list">
						<span class="cl_gray f18px">院校所在地：</span>
						<el-select v-model="sdValue" clearable placeholder="不限" @change="sdSelect">
							<el-option v-for="item in sd":key="item.id" :label="item.name":value="item.id"></el-option>
						</el-select>
					</div>
					<div class="famous_screen_list">
						<span class="cl_gray f18px">院校类型：</span>
						<el-select v-model="typeValue" clearable placeholder="不限" @change="typeSelect">
							<el-option v-for="item in type":key="item" :label="item":value="item"></el-option>
						</el-select>
					</div>
					<div class="famous_screen_list">
						<span class="cl_gray f18px">院校层次：</span>
						<el-select v-model="ccValue" clearable placeholder="不限" @change="ccSelect">
							<el-option v-for="item in cc":key="item" :label="item":value="item"></el-option>
						</el-select>
					</div>
				</div>
				<div class="choice_uv f18px cl_violet tc" v-if="status == 2">
					<span @click="popupShow(1)">{{university_name == "" ? "+选择院校" : university_name}}</span>
					<span @click="popupShow(2)">{{major_name == "" ? "+选择专业" : major_name}}</span>
				</div>
				<div class="choice_table_cont" v-if="list.length > 0">
					<table class="choice_table">
						<thead>
							<tr class="f18px">
								<th width="300px">院校名称</th>
								<th width="300px">专业名称</th>
								<th width="200px">本专科批次</th>
								<th width="200px">首选科目</th>
								<th width="200px">再选科目</th>
							</tr>
						</thead>
						<tbody class="f16px cl_dark">
							<tr v-for="(item,index) in list" :key="index">
								<td>
									<router-link :to="{ path: '/treasury_details', query: { id: item.university_id, type: 4}}" class="f18px cl_black">{{item.university_name}}</router-link>
									<div class="choice_table_tip f12px tc mat20">
										<div class="choice_table_item cl_white" v-for="(item,index) in item.featureList" :key="index" :class="[{'first': item == '985工程'},{'second': item == '211工程'}]">{{item}}</div>
										<div class="choice_table_item choice_table_item_last cl_violet" v-if="item.city_name != null">{{item.city_name}}</div>
									</div>
								</td>
								<td><p>{{item.major_name}}</p></td>
								<td align="center"><p>{{item.level}}</p></td>
								<td align="center">
									<p v-if="item.subject_one_name_data.length == 0">不限</p>
									<p v-else>{{item.subject_one_name_data[0]}}(必选)</p>
								</td>
								<td align="center">
									<p v-if="item.subject_two_name_data.length == 0">不限</p>
									<p v-else><span v-for="(item,index) in item.subject_two_name_data" :key="index">{{item}} </span>({{item.subject_two_name_data.length}}选1)</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray">共 {{total}} 条记录 页次：{{currentPage}}/{{Math.ceil(total/pageSize)}}页   {{pageSize}}条/页</div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next, jumper" @size-change="handleSizeChange" 
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<p>数据为空，请重新选择组合</p>
				</div>
			</div>
		</div>
		<vfooter></vfooter>
		
		<!-- 院校,专业弹窗 -->
		<div class="bg" @click="degreeClose" v-if="degreeShow == true"></div>
		<div class="popup bg_white radius8" :class="{'on':degreeShow}">
			<div class="popup_title flex f18px">
				<p v-if="degreeType == 1">选择院校</p>
				<p v-else>选择专业</p>
				<img src="../../../static/close_violet.png"  @click="degreeClose" />
			</div>
			<div class="popup_cont" v-if="degreeType == 1">
				<div class="popup_cont_top cl_violet">
					<span class="popup_province" v-for="(item,index) in sd" :key="index" @click="selectPro(item.id)" :class="{'on':province_id==item.id}">{{item.name}}</span>
				</div>
				<div class="popup_cont_btm mat10">
					<span class="popup_un bg_gray clip" v-for="(item,index) in university_list" :key="index" @click="selectUn(item.id)">{{item.name}}</span>
				</div>
			</div>
			<div class="popup_cont" v-else>
				<div class="popup_cont_btm mat10">
					<span class="popup_un bg_gray clip" v-for="(item,index) in major_list" :key="index" @click="selectMajor(item.major_id)">{{item.major_name}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'choice_subject',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 1,
				status: 1, //1条件筛选2精选
				ccValue: "", //院校层次
				cc: [],
				sdValue: "", //院校属地
				sd: [],
				typeValue: "", //院校类型
				type: [],
				province_id: "", //省份id
				university_list: [],
				university_name: "",
				university_id: "", //校园id
				major_list: [],
				major_name: "",
				major_id: "", //专业id
				degreeShow: false, //弹窗显示
				degreeType: 1, //弹窗类型
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总条数
				list: [], //院校列表
			}
		},
		mounted() {
			this.getUni();
			this.getSd();
			this.getType();
			this.getList();
		},
		created() {
			
		},
		methods: {
			//院校层次
			getUni () {
				var that = this;
				that.$get("/api/careerbible/get_level_data",{})
				.then(res => {
					that.cc = res.data;
					//that.ccValue = that.cc[0];
				});
			},
			//院校属地
			getSd () {
				var that = this;
				that.$get("/api/careerbible/get_province_data",{})
				.then(res => {
					that.sd = res.data;
					// that.sdValue = that.sd[0].id;
				});
			},
			//院校类型
			getType () {
				var that = this;
				that.$get("/api/careerbible/get_type_data",{})
				.then(res => {
					that.type = res.data;
					// that.typeValue = that.type[0];
				});
			},
			//筛选类型
			intentNav (e) {
				if (e == 1) {
					
				} else {
					this.ccValue = "";
					this.sdValue = "";
					this.typeValue = "";
				}
				this.status = e;
				this.getList();
			},
			//弹窗显示
			popupShow (e) {
				if (e == 1) {
					this.degreeType = 1;
					this.getUn();
				} else {
					this.degreeType = 2;
					if (this.university_id == "") {
						this.$message({
							duration: 1500,
							message: "请先选择院校",
							type: 'wrong'
						});
						return false
					}
					this.getMajor();
				}
				this.degreeShow = true;
			},
			//选择省份
			selectPro (e) {
				this.province_id = e;
				this.getUn();
			},
			//选择院校
			selectUn (e) {
				this.university_id = e;
				for (let i = 0; i < this.university_list.length; i++) {
					if (e == this.university_list[i].id) {
						this.university_name = this.university_list[i].name;
					}
				}
				this.getList();
				this.degreeClose();
			},
			//选择专业
			selectMajor (e) {
				this.major_id = e;
				for (let i = 0; i < this.major_list.length; i++) {
					if (e == this.major_list[i].major_id) {
						this.major_name = this.major_list[i].major_name;
					}
				}
				this.getList();
				this.degreeClose();
			},
			//获取学校列表
			getUn () {
				var that = this;
				if (that.province_id == "") {
					that.province_id = that.sd[0].id;
				}
				that.$get("/api/selectsubject/get_university_show_data",{province_id: that.province_id})
				.then(res => {
					that.university_list = res.data;
				});
			},
			//获取专业列表
			getMajor () {
				var that = this;
				that.$get("/api/selectsubject/get_major_show_data",{university_id: that.university_id})
				.then(res => {
					that.major_list = res.data;
				});
			},
			degreeClose () {
				this.degreeShow = false;
			},
			//获取学校
			getList () {
				var that = this;
				that.$get("/api/selectsubject/get_apply_major_data",{
					token: localStorage.getItem("token"),
					page: that.currentPage,
					limit: that.pageSize,
					status: that.status,
					province_id: that.sdValue,
					type: that.typeValue,
					level: that.ccValue,
					university_id: that.university_id,
					major_id: that.major_id,
				})
				.then(res => {
					that.list = [];
					that.list = res.data.data;
					that.total = res.data.total;
					for (let i = 0; i < that.list.length; i++) {
						that.list[i].featureList = [];
						if (that.list[i].feature != '' && that.list[i].feature != null) {
							that.list[i].featureList = that.list[i].feature.split(",");
						}
					}
				});
			},
			//下拉选择
			ccSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			sdSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			typeSelect (e) {
				this.currentPage = 1;
				this.getList();
			},
			handleSizeChange: function (size) {
							this.pageSize = size;
							console.log(this.pageSize)  //每页下拉显示数据
			},
			handleCurrentChange: function(currentPage){
							this.currentPage = currentPage;
							this.getList();
							console.log(this.currentPage)  //点击第几页
			},
		},
	}
</script>

<style>
</style>
